export const displayInitials = (name) => {
  if (!name) return;
  const splitName = name.split(" ");
  const result = splitName[0].charAt(0);
  return result;
};
